<div
  [ngClass]="!isLoggedIn ? 'logged-out-header' : 'logged-in-header'"
  class="menu-section"
>
  <div>
    <a [routerLink]="['/']" class="brand">
      <a [routerLink]="['/']" class="second-logo"></a>
    </a>
    <div class="social-icons hide-mobile">
      <a (click)="navigate('listing/9216/partnerchoice-app')"
        ><span class="fa fa-fw fa-lg fa-brands fa-apple"></span
      ></a>
      <a (click)="navigate('listing/9216/partnerchoice-app')"
        ><span class="fa fa-fw fa-lg fa-brands fa-android"></span
      ></a>
      <a (click)="navigate('Users/my-favourites')"
        ><span class="fa fa-fw fa-lg fa-heart"></span
      ></a>
      @if (gazetteUrl) {
      <a [href]="gazetteUrl" target="blank" class="gazette"
        ><img
          class="fa fa-fw fa-lg"
          src="/app/assets/img/homepage/Gazette_Logo.png"
      /></a>
      }
    </div>
  </div>
  <nav class="top-nav">
    <ul class="inline-list left hide-desktop">
      <li
        id="mobileHamburger"
        class="left-panel-button fa fa-fw fa-lg fa-bars modal-container"
      ></li>
      @if (isLoggedIn) {
      <li class="fa fa-fw fa-lg fa-home" [routerLink]="['/']"></li>
      }
    </ul>
    <div class="hide-desktop mobile-logo"></div>

    @if (isLoggedIn) {
    <ul class="inline-list right account-links" id="account">
      <li
        id="mobileSearch"
        class="top-panel-button fa fa-fw fa-lg fa-search hide-desktop modal-container"
      ></li>
      <li
        class="right-panel-button fa fa-fw fa-lg fa-user modal-container"
        id="account"
      >
        @if (user) {
        <span class="user-name-dropdown hide-mobile" id="account">
          {{ user.first_name + ' ' + user.last_name }}
          <span id="account" class="fa fa-chevron-circle-down"></span>
        </span>
        }
      </li>
      <li class="my-branch-shortcut hide-mobile">
        <a [routerLink]="['/Users/my-branch']">
          <span class="fa fa-fw fa-calendar" aria-hidden="true"></span> My Branch
        </a>
      </li>
    </ul>
    }
    <div class="left-panel">
      <nav>
        <ul>
          <li>
            <a href="https://jlpleisurebenefits.zendesk.com/home" title=""
              >Help?</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </nav>
  @if (isLoggedIn) {
  <search-panel
    [isLoggedIn]="isLoggedIn"
    [(mobileSearchOpen)]="mobileSearchOpen"
    [(gazetteUrl)]="gazetteUrl"
  />
  }
  <user-menu [isAdmin]="user?.isAdmin" />
</div>
